var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"app"}},[_c('TodoListTitle',{attrs:{"title":_vm.title}}),_c('div',{staticClass:"container"},[_c('FormInput',{on:{"addTodo":_vm.addTodo}}),_c('TodoList',{attrs:{"list":_vm.list},on:{"delTodo":_vm.delTodo}}),_c('FooterTotal',{attrs:{"list":_vm.list},on:{"clear":_vm.clear}})],1)],1),_c('FooterCopyright')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }